export function setMetaData({ title, description }: { title: string, description: string }) {
    document.title = title;
    const metaDescriptionEl = document.querySelector('meta[name="description"]');
    if (metaDescriptionEl) {
        metaDescriptionEl.setAttribute('content', description.replace(/<[^>]*>/g, ''));
    } else {
        const metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'description');
        metaTag.setAttribute('content', description.replace(/<[^>]*>/g, ''));
        document.head.appendChild(metaTag);
    }
}